import * as React from "react";
import { getDisplayName } from "@grandvisionhq/utils";
function withServerRouteFormatters(localRouteFormatters) {
  return (PageComponent) => {
    const displayName = getDisplayName(PageComponent);
    const WithServerRouteFormatters = (pageProps) => {
      return /* @__PURE__ */ React.createElement(PageComponent, { ...pageProps });
    };
    WithServerRouteFormatters.getInitialProps = async (appContext) => {
      let pageProps = {};
      if (PageComponent.getInitialProps) {
        pageProps = await PageComponent.getInitialProps({
          ...appContext,
          localRouteFormatters
        });
      }
      if (typeof PageComponent.getInitialProps === "function") {
        return pageProps;
      }
      return {};
    };
    WithServerRouteFormatters.displayName = `WithServerRouteFormatters(${displayName})`;
    return WithServerRouteFormatters;
  };
}
export {
  withServerRouteFormatters
};
//# sourceMappingURL=with-server-route-formatters.js.map
